import React, { Component, PropTypes } from 'react'

export default class Button extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <button type={this.props.type} className={this.props.className} onClick={this.props.onClick}>
        {this.props.text}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/components/Button.js